import { useMutation, useQuery, useSubscription } from "urql";
import moment from "moment";

const GET_NOTIFICATIONS = `
  query GET_NOTIFICATIONS ($userId: String! $companyId: String!) {
    getNotifications(userId: $userId, companyId: $companyId)
  }
`;

export const GetNotifications = (userId, companyId) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_NOTIFICATIONS,
    variables: { userId, companyId },
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const APP_NOTIFICATIONS = `subscription APP_NOTIFICATIONS ($userId: String!) {
    notificationsReceived(userId: $userId) {
      id
      content
      createdAt
      redirectUrl
      referenceType
      botname
      recipients {
        user
        isRead
      }
      company {
        alias
        id
        name
        plan
        rut
        suscriptionId
        trialExpirationDate
      }
      reference {
        ... on Document {
          meta  {
            ... on TaxDocumentMeta {
              documentId
            }
            ... on ObligationMeta {
              documentId
            }
          }
        }
      }
      sender {
        id
        profile {
          firstName
          lastName
        }
      }
    }
}`;

export const AppNotificationsSuscription = (userId) => {
  const handleSubscription = (messages = [], response) => {
    let formattedNotifications = [];
    if (response) {
      const { notificationsReceived } = response;

      for (const notification of notificationsReceived) {
          let formattedNotification = {};

          if (notification?.botname) {
            formattedNotification = {
              title: `Conexión: ${notification?.botname}`,
              comment: notification?.content || "",
              ago: moment(notification?.createdAt).format("DD-MM-YYYY HH:mm:ss"),
              id: notification?.id,
              notification: notification,
              recipients: notification?.recipients
            };
            formattedNotifications.push(formattedNotification);
          } else {
            const senderFullName = `${notification?.sender?.profile?.firstName || ""
              } ${notification?.sender?.profile?.lastName || ""}`;
            formattedNotification = {
              title: `${senderFullName} te ha mencionado en un comentario`,
              description: `Empresa ${notification?.company?.alias || notification?.company?.name} - ${notification?.referenceType == "document"
                ? notification?.reference?.meta?.documentId
                  ? `Documento con folio #${notification?.reference?.meta?.documentId}`
                  : "Apartado de documentos"
                : "En el apartado de Conciliación Bancaria"}`,
              comment: notification?.content || "",
              ago: moment(notification?.createdAt).format("DD-MM-YYYY HH:mm:ss"),
              id: notification?.id,
              redirectUrl: notification?.redirectUrl,
              notification: notification,
              recipients: notification?.recipients,
              company: notification?.company
            };
            formattedNotifications.push(formattedNotification);
          }
      }

      return formattedNotifications;
    }

    return [{}];
  };

  const [res] = useSubscription(
    {
      query: APP_NOTIFICATIONS,
      variables: { userId },
    },
    handleSubscription
  );

  return res;
};

export const MARK_NOTIFICATION_AS_READ = `
  mutation MARK_NOTIFICATION_AS_READ(
    $notificationId: String!
    $userId: String!
    $companyId: String!
  ) {
    markNotificationAsRead(notificationId: $notificationId, userId: $userId, companyId: $companyId)
  }
`;

export const MarkNotificationAsReaded = () => {
  const [result, executeMutation] = useMutation(MARK_NOTIFICATION_AS_READ);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};
